import { isBrowser } from './is-browser.js';
export const loadScript = (src) => new Promise((resolve, reject) => {
    if (isBrowser()) {
        const s = document.createElement('script');
        s.onload = () => resolve();
        s.onerror = (err) => reject(err);
        s.src = src;
        document.body.appendChild(s);
    }
});
//# sourceMappingURL=load-script.js.map